import { React, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'normalize.css';

const MachineCreate = () => {
  const [formData, setFormData] = useState({
    company: "",
    machineModel: "",
    client: "",
    machineForm: "",
    dataId: "",
    measurementTime: "",
    deliveryTime: "",
    measurementLocation: "",
    customerRemarks: "",
    controllerType: "",
    travelX: "",
    motorSpecX: "",
    travelY: "",
    motorSpecY: "",
    travelZ: "",
    motorSpecZ: ""
  });

  //將圖片轉成base64(字串)，並存到formData中
  const handleFileChange = async (e, fileKey) => {
    const file = e.target.files[0];
    try {
      const imageData = await convertToBase64(file);
      setFormData((prev) => ({ ...prev, [fileKey]: imageData }));
    } catch (error) {
      console.error("轉換錯誤：", error);
    }
  };
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve({ image: reader.result });
      };
      reader.onerror = (error) => {
        console.error("Error reading file:", error);
        reject(error);
      };
    });
  };

  const navigate = useNavigate();
  const onMachineManagement = (e) => {
    e.preventDefault();
    navigate('/machine-management');
  };
  const onFrequencyResponseFunction = (e) => {
    e.preventDefault();
    localStorage.setItem("KeepData", JSON.stringify(formData));
    //alert("已儲存變更");
    console.log('基本資料傳遞', formData)
    navigate('/frequency-response-function/x  ', { state: { formData } });
  };

  useEffect(() => {
    const savedData = localStorage.getItem("KeepData");
    if (savedData) {
      setFormData(JSON.parse(savedData));
    }
  }, []);

  const handleChange = (event) => {
    const { id, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  return (
    <div className="d-flex flex-column flex-md-row" style={{ width: '81.7%', margin: '0 auto' }}>
      <div className="container-fluid">
        <div style={{ height: '35px', width: '100%' }}></div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item" >
              <a href="#" onClick={onMachineManagement} style={{ color: '#B0B7C3', fontWeight: 'bold', fontSize: '15px' }}>機台資料庫</a>
            </li>
            <li
              className="breadcrumb-item"
              aria-current="page"
              style={{ color: '#5B82B1', fontWeight: 'bold', fontSize: '15px' }}>新增資料
            </li>
          </ol>
        </nav>

        <div style={{ height: '10px', width: '100%' }}></div>

        <form >
          <div className=" d-flex flex-column">
            <span className="sub-title">基本資料</span>
            <div style={{ height: '35px', width: '100%' }}></div>

            <div className="d-flex flex-column flex-md-row">
              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="company" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >廠商</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="company" value={formData.company} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="client" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >客戶</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="client" value={formData.client} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="dataId" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >資料ID</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="dataId" value={formData.dataId} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="deliveryTime" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >交機時間</label>
                  <div className="col-sm-9">
                    <input type="datetime-local" className="form-control" id="deliveryTime" value={formData.deliveryTime} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="customerRemarks" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >客戶備註</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="customerRemarks" value={formData.customerRemarks} onChange={handleChange} />
                  </div>
                </div>
              </div>

              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="machineModel" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >機台型號</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="machineModel" value={formData.machineModel} onChange={handleChange} />
                  </div>
                </div>

                <div className=" row mb-3">
                  <label htmlFor="machineForm" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >機台形式</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="machineForm" value={formData.machineForm} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="measurementTime" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >測量時間</label>
                  <div className="col-sm-9">
                    <input type="datetime-local" className="form-control" id="measurementTime" value={formData.measurementTime} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="measurementLocation" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >測量地點</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="measurementLocation" value={formData.measurementLocation} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="controllerType" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }} >控制器類型</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="controllerType" value={formData.controllerType} onChange={handleChange} />
                  </div>
                </div>

              </div>
            </div>

            <div style={{ height: '35px', width: '100%' }}></div>

            <span className="sub-title">機台資料</span>
            <div style={{ height: '35px', width: '100%' }}></div>

            <div className="d-flex flex-column flex-md-row">
              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="travelX" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>X軸行程</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="travelX" value={formData.travelX} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="travelY" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>Y軸行程</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="travelY" value={formData.travelY} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="travelZ" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>Z軸行程</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="travelZ" value={formData.travelZ} onChange={handleChange} />
                  </div>
                </div>
              </div>
              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="motorSpecX" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>X軸馬達規格</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="motorSpecX" value={formData.motorSpecX} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="motorSpecY" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>Y軸馬達規格</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="motorSpecY" value={formData.motorSpecY} onChange={handleChange} />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="motorSpecZ" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>Z軸馬達規格</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="motorSpecZ" value={formData.motorSpecZ} onChange={handleChange} />
                  </div>
                </div>
              </div>
            </div>

            <div style={{ height: '35px', width: '100%' }}></div>
            <span className="sub-title">測量記錄</span>
            <div style={{ height: '35px', width: '100%' }}></div>

            <div className="row mb-3 align-items-center">
              <label htmlFor="formFile_1" className="col-sm-1 col-form-label" style={{ minWidth: "100px" }}>量測點位</label>
              <div className="col" style={{ flex: "0 0 87.5%" }}>
                <input type="file" className="form-control" id="formFile_1" accept="image/*" onChange={(e) => handleFileChange(e, 'measurementPointFile')} />
              </div>
            </div>

            <div className="row mb-3 align-items-center">
              <label htmlFor="formFile_2" className="col-sm-1 col-form-label" style={{ minWidth: "100px" }}>敲擊位置</label>
              <div className="col" style={{ flex: "0 0 87.5%" }}>
                <input type="file" className="form-control" id="formFile_2" accept="image/*" onChange={(e) => handleFileChange(e, 'impactPositionFile')} />
              </div>
            </div>

            <div className="row mb-3 align-items-center">
              <label htmlFor="formFile_3" className="col-sm-1 col-form-label" style={{ minWidth: "100px" }}>機台型式</label>
              <div className="col" style={{ flex: "0 0 87.5%" }}>
                <input type="file" className="form-control" id="formFile_3" accept="image/*" onChange={(e) => handleFileChange(e, 'machineImageFile')} />
              </div>
            </div>
          </div>

          <div style={{ height: '15px', width: '100%' }}></div>

          <div className="d-flex justify-content-end gap-3" style={{ paddingRight: "60px" }}>
            <button
              className="btn-cancel"
              style={{ height: '35px', width: '60px' }}
              onClick={onMachineManagement}
              type="button"
            >
              取消
            </button>
            <button
              className="btn-confirm btn-primary"
              style={{ height: '35px', width: '60px' }}
              onClick={onFrequencyResponseFunction}
              type="button"
            >
              下一步
            </button>
          </div>
          <div style={{ height: '60px', width: '100%' }}></div>
        </form>
      </div>
    </div>
  );
};

export default MachineCreate;